export default class AdjustmentViewModel {
    public id: number = 0;
    public amount: number = 0;
    public period: string = '';
    public type: string = '';
    public endOfPeriodDate: Date | null = null;
    public execId: string | null = null;
    public accountId: string | null = null
    public notes: string | null = null;
}